import { Group, Text } from "@mantine/core"
import { IconFileUnknown } from "@tabler/icons-react"
import { theme } from "@tfg/themes"
import { useTranslation } from "react-i18next"

import { DocumentDownload } from "~/components/DocumentDownload"
import { DocumentView } from "~/components/DocumentView"

type Props = {
  documentName: string | null
  documentId: string | null
  filename?: string
  canView?: boolean
  canDownload?: boolean
}

export const DocumentActionsCell = ({
  documentId,
  documentName,
  filename,
  canView = true,
  canDownload = true,
}: Props) => {
  const { t } = useTranslation()

  if (!documentId || !documentName) {
    return (
      <Group>
        <IconFileUnknown color={theme.colors.gray[7]} />
        <Text>{t("document.missingDocument")}</Text>
      </Group>
    )
  }

  return (
    <Group wrap="nowrap">
      {canView ? <DocumentView documentId={documentId} /> : null}
      {canDownload ? (
        <DocumentDownload
          documentId={documentId}
          documentName={documentName}
          filename={filename}
        />
      ) : null}
    </Group>
  )
}
